import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from '../form-control.service';
import { FormItem } from '../form-item';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [FormControlService],
})
export class DynamicFormComponent implements OnInit {
  @Input() formItems: FormItem<string>[] = [];
  form!: FormGroup;
  @Output() formSubmit = new EventEmitter();

  constructor(private formControlService: FormControlService) {}

  ngOnInit(): void {
    this.form = this.formControlService.toFormGroup(this.formItems);
  }

  onSubmit(): void {
    this.formSubmit.emit(this.form.getRawValue());
    this.form.reset();
  }
}
